import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading, WideCardFilter } from '../Main'
// import { Link } from 'react-router-dom'
import OrderShippingTable from '../../containers/order/shipping/OrderShippingTable'

const WideCardOrderShipping = (data) => {
  const { loading, payload, download } = data
  const { t } = useTranslation()

  const [payloadFilter, setPayloadFilter] = useState(payload)
  const [loadingRequest] = useState(false)
  const filter = {
    text_search: true,
    status: {
      multiple: true,
      options: [
        { value: 'SHIPPED', label: t(`status.bill.SHIPPED`) },
        { value: 'DELIVERED', label: t(`status.bill.DELIVERED`) },
        { value: 'CANCELLED', label: t(`status.bill.CANCELLED`) },
        { value: 'CORRECTION', label: t(`status.bill.CORRECTION`) },
      ],
    },
    download: download,
  }

  const handleFilter = (row) => {
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    objPayload.keywords.text_search = row?.keywords.text_search
    objPayload.keywords.status = row?.keywords.status
    data.handleFilter(objPayload)
    setPayloadFilter(objPayload)
  }

  useEffect(() => {
    setPayloadFilter(payload)
  }, [payload])

  // CARD AREA
  // const CardHeader = (data) => {
  //   const row = data.data

  //   return (
  //     <>
  //       <div className="row">
  //         <div className="col-8 mt-2">
  //           <span className="d-inline-block p-2">
  //             <small>{t('title.bill.invoice_code')}</small> <br />
  //             <strong>{row?.invoice_code}</strong>
  //           </span>
  //         </div>
  //         <div className="col-4 mt-1 d-flex justify-content-end">
  //           <span className="d-inline-block py-4">
  //             <small>{t('title.bill.status')}: </small>
  //             <span className={`text-gray font-weight-bold text-gray`}>
  //               {t(`status.bill.${row?.status}`)}
  //             </span>
  //           </span>
  //         </div>
  //       </div>
  //       <hr className="m-0" />
  //     </>
  //   )
  // }

  // const CardFooter = (dataItems) => {
  //   return (
  //     <>
  //       <hr className="m-0" />
  //       <div className="row">
  //         <div className="col-12 mt-2 mb-2 d-flex justify-content-end">
  //           <Link to={'/page/help'} className="d-inline btn btn-red btn-xs m-3 font-size-10">
  //             <i className="fa fa-question-circle"></i> {t('button.help')}
  //           </Link>
  //         </div>
  //       </div>
  //     </>
  //   )
  // }

  return (
    <>
      {/* FILTER */}
      <WideCardFilter
        filter={filter}
        payload={payload}
        handleFilter={handleFilter}
        label_input={t('placeholder.shipping_filter')}
      />
      {loading || loadingRequest ? (
        <div className="d-flex justify-content-center">
          <Loading />
        </div>
      ) : (
        <>
          <div>
            <div className="border border-width-2 border-color-3 borders-radius-6 container wide-card rounded mb-5">
              {/* <CardHeader data={data} /> */}
              <div className="row">
                <div className="col-12">
                  <OrderShippingTable data={data} />
                </div>
              </div>
              {/* <CardFooter data={data} /> */}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default WideCardOrderShipping
